import { Link, graphql, useStaticQuery } from 'gatsby'
import { sortBy } from 'lodash'
import { renderAsText } from '../../utility.js'
import moment from 'moment'
import React from 'react'
import Button from '../button/button-link.js'
import * as styles from './index.module.css'

const EventsBlock = () => {
  const eventsQuery = useStaticQuery(graphql`
    query EventsBlockQuery {
      allPrismicSpecialEvent {
        nodes {
          data {
            activity_time {
              start_time
            }
            title {
              richText
              text
            }
            spot_images {
              alt
              url
            }
          }
          url
          id
          tags
          type
          uid
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  `)
  const data = eventsQuery.allPrismicSpecialEvent.nodes
  if (data.length === 0) {
    return null
  }

  let events = data

  // BUILD EVENT TIMES
  let eventTimes = []
  let today = moment()
  events.forEach((event) => {
    if (event?.data?.activity_time) {
      event?.data?.activity_time.forEach((time) => {
        if (time.start_time && moment(time.start_time).isSameOrAfter(today)) {
          eventTimes.push(
            Object.assign({}, time, {
              link_type: event.data.link_type,
              _meta: event.data._meta,
              title: event.data.title,
              image: event.data.spot_images,
              url: event.url,
            })
          )
        }
      })
    }
  })

  // SORT BY TIME
  let eventsByTime = sortBy(eventTimes, [(d) => d.start_time])

  if (!eventsByTime) return null

  return (
    <React.Fragment>
      <h3 className={`${styles.eventBlockHeader}`}>Upcoming Events</h3>
      <div className={`${styles.eventBlockWrapper}`}>
        {eventsByTime.slice(0, 2).map((d) => (
          <React.Fragment key={Math.random(0, 9999999)}>
            <div className={`${styles.eventItemWrapper}`}>
              <div className={`${styles.eventImageWrapper}`}>
                <Link to={d.url}>
                  <img
                    src={d.image ? d.image.url : ''}
                    alt={d.image?.alt}
                    className={`${styles.eventImage} img-fluid`}
                  />
                </Link>
              </div>
              <h4 className={`${styles.eventItemTitle}`}>{d.title.text}</h4>
              {d.start_time && (
                <p className={`${styles.eventItemDate}`}>
                  {moment(d.start_time).format('MMMM D')}
                </p>
              )}
            </div>
          </React.Fragment>
        ))}
        <a href="/events" className={`${styles.eventMoreButtonMobile}`}>
          <img src="/images/more-arrow.png" alt="More" />
          <div className={`${styles.eventMoreText}`}>More</div>
        </a>
      </div>
      <a href="/events" className={`${styles.eventMoreButton}`}>
        <img src="/images/more-arrow.png" alt="More" />
        <div className={`${styles.eventMoreText}`}>More</div>
      </a>
      <div className={`${styles.activitiesMobile}`}>
        <Button text="Activities" url="/daily-schedule" size="smallLongText" />
      </div>
    </React.Fragment>
  )
}

export default EventsBlock
